import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Send, Upload } from "lucide-react";
import { cn } from "@/lib/utils";
import { useIsMobile } from "@/hooks/use-mobile";

interface ChatInputProps {
  value: string;
  onChange: (value: string) => void;
  onSend: () => void;
  onFileUpload: () => void;
  isLoading?: boolean;
}

export function ChatInput({
  value,
  onChange,
  onSend,
  onFileUpload,
  isLoading
}: ChatInputProps) {
  const isMobile = useIsMobile();

  return (
    <div className={cn(
      "flex flex-col gap-2",
      isMobile && "sticky bottom-0 left-0 right-0 bg-background/95 backdrop-blur-sm border-t z-50"
    )}>
      <div className="flex flex-col md:flex-row gap-2">
        <Textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Skriv din melding her..."
          className={cn(
            "resize-none min-h-[48px] md:min-h-0 flex-1",
            "bg-white dark:bg-gray-900",
            "border-2 focus:border-[#FF6A00] focus:ring-[#FF6A00]",
            isMobile && "text-base"
          )}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              onSend();
            }
          }}
        />
        <div className="flex gap-2 w-full md:w-auto">
          <Button 
            onClick={onFileUpload}
            disabled={isLoading}
            size="lg"
            variant="outline"
            className={cn(
              "flex-1 md:flex-none min-h-[48px] min-w-[48px] px-4",
              "bg-white dark:bg-gray-900 hover:bg-gray-50 dark:hover:bg-gray-800",
              "border-2 border-[#FF6A00] text-[#FF6A00]",
              "font-semibold shadow-sm",
              "transition-colors duration-200"
            )}
          >
            <Upload className="h-4 w-4 md:mr-2" />
            {isMobile && <span className="ml-2">Last opp</span>}
          </Button>
          <Button 
            onClick={onSend}
            disabled={isLoading || !value.trim()}
            size="lg"
            className={cn(
              "flex-1 md:flex-none min-h-[48px] min-w-[48px] px-4",
              "bg-[#FF6A00] hover:bg-[#FF8533]",
              "text-white font-semibold shadow-sm",
              "transition-colors duration-200"
            )}
          >
            <Send className="h-4 w-4 md:mr-2" />
            {isMobile && <span className="ml-2">Send</span>}
          </Button>
        </div>
      </div>
      {isMobile && <div className="h-3" />}
    </div>
  );
}